import request from '../utils/request';
import { ITranslation } from '../utils/translations';
import {ISport, ICompetition, IStatesArr, IWidget, IChannel} from '../utils/types';
import {ITableCompetition} from "../components/OddsComparisonTable";
import {IOutLinks} from "./match-center";

interface IDataForFiltersResp {
  sports: ISport[];
  competitions: ICompetition[];
  statesArr: IStatesArr;
}

export interface IWidgetResponse extends IWidget {
  translations: ITranslation[],
  widgetCompetitions: any[],
  widgetProviders: any[],
  widgetSports: any[],
  widgetStyles: any[],
  widgetMetas: any[],
  channel: IChannel | null,
  channelOutLinkFolder: string | null,
  outLinks: IOutLinks;
}

export function fetchDataForFilters(query: object) {
  return request('/api/odds-comparison/data-for-filters', query) as unknown as Promise<IDataForFiltersResp>;
}

export function fetchTableData(query: object) {
  return request('/api/odds-comparison/table-data', query) as unknown as Promise<ITableCompetition[]>;
}

export function fetchWidgetData(query: object) {
  return request(`/api/odds-comparison/widget-data`, query) as unknown as Promise<IWidgetResponse>;
}
